<template>
  <p class="text-weight-medium text-body text-grey-8 q-mb-sm full-width">
    <slot />
  </p>
</template>

<script>
export default {
  name: 'SAIFormLabel'
};
</script>
